import {ApprovalStatusType, BillingType, ContractType} from "@app/shared";

export class ContractInfo {
  id: number;
  subtype: ContractType;
  hasClins: boolean;
  contractNumber: string;
  contractTitle: string;
  awardDate: Date;
  description: string;
  currentStatus: ApprovalStatusType;
  customerId: number;
  customerBusinessName: string;
  startDate: string;
  endDate: string;
  billingType: BillingType;
  programManager: string;
  department: string;
  totalValue: number;
  totalFundedValue: number;
  subjectToExecutiveOrder?: boolean;
}

